import React from "react";
import { Typography } from "@mui/material";

function Error() {
  return (
    <>
      <Typography variant="h1" sx={{ mb: 7 }}>
        Oops!
      </Typography>
      <Typography variant="">
        Something went wrong within the registration process.
      </Typography>

      <Typography sx={{ my: 7 }} variant="h5">
        Thanks You!
      </Typography>
    </>
  );
}

export default Error;
